import { useState } from 'react'
import { useSelector } from 'react-redux'
import { templatesSelectModalSelector } from 'store/modals'
import ConfirmModal from 'ui/components/ConfirmModal'
import ModalBasic from 'ui/components/ModalBasic'
import TemplatesSelectItem from './components/TemplatesSelectItem'
import { TemplatesSelectStyled } from './styled'
import { LEXICAL_EMPTY_PARAGRAPH_HTML } from '../../constants'

const TemplatesSelectModal = ({
  descriptionValue,
  appliedTemplateContent,
  applyDescriptionTemplate,
  open,
  handlerClose,
}) => {
  const [expandedIds, setExpandedIds] = useState([])
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [pendingContent, setPendingContent] = useState(null)

  const { title, templates } = useSelector(templatesSelectModalSelector)

  const closeModal = () => {
    setExpandedIds([])
    handlerClose()
  }

  const closeConfirm = () => {
    setConfirmOpen(false)
    setPendingContent(null)
  }

  const apply = (content) => {
    applyDescriptionTemplate(content)
    closeModal()
  }

  const handleApplyClick = (content) => {
    const isEmpty = descriptionValue === LEXICAL_EMPTY_PARAGRAPH_HTML
    const isSameTemplate = descriptionValue === content

    const hasAppliedTemplate = !!appliedTemplateContent
    const templateWasEdited =
      hasAppliedTemplate && descriptionValue !== appliedTemplateContent

    const shouldWarn =
      !isEmpty && !isSameTemplate && (!hasAppliedTemplate || templateWasEdited)

    if (shouldWarn) {
      setPendingContent(content)
      setConfirmOpen(true)
      return
    }

    apply(content)
  }

  return (
    <>
      <ModalBasic
        open={open}
        size="templatesSelect"
        handlerClose={closeModal}
        title={title}
      >
        <TemplatesSelectStyled>
          {templates?.length > 0 &&
            templates.map((template) => {
              const isExpanded = expandedIds.includes(template.id)

              return (
                <TemplatesSelectItem
                  key={template.id}
                  id={template.id}
                  name={template.name}
                  tag={template.task_type}
                  template={template.content}
                  expanded={isExpanded}
                  onToggle={(id, next) => {
                    setExpandedIds((prev) =>
                      next
                        ? [...prev, id]
                        : prev.filter((expandedId) => expandedId !== id)
                    )
                  }}
                  onApply={() => handleApplyClick(template.content)}
                />
              )
            })}
        </TemplatesSelectStyled>
      </ModalBasic>
      <ConfirmModal
        title="Заменить данные?"
        text="Текущее описание будет удалено и заменено новым шаблоном. Продолжить?"
        open={confirmOpen}
        confirmHandler={() => {
          apply(pendingContent)
          closeConfirm()
        }}
        handlerClose={() => closeConfirm()}
        confirmText="Заменить"
        cancelText="Отменить"
      />
    </>
  )
}

export default TemplatesSelectModal
